
import {GrayBtn, WhiteBtn, WhiteBtnTxt, GrayBtnTxt} from "./Button.module.css";
import Typography from "@mui/material/Typography";

function Button({onClick,variant, children,className, selected, style}) {
  
  var newClassName = selected ? GrayBtn : WhiteBtn;
  if (className) {
    newClassName += " " + className;
  }

  return (
    <button className={newClassName} onClick={onClick} style={style}>
      <Typography variant={variant} className={selected ? GrayBtnTxt : WhiteBtnTxt}>
        {children}
      </Typography>
    </button>
  );
}

export default Button;
